<template>
    <div class="niste-clan">
      <div>Za pristup traženom modulu nemate dovoljne ovlasti. Molimo vas da se obratite upravitelju aplikacije.</div>
      <a @click="sendTwoBack()">Povrat na prethodni pogled</a>
    </div>
  </template>
  
  <script>
  export default {
      methods:{
        sendTwoBack()
        {
            this.$router.go(-1)
        }
      }
  
  }
  </script>
  
  <style>
  
  </style>